//read more button
$( "<a class='readMore' style='cursor:pointer;color:#000;font-size:1em;font-weight:500'>[Read More...]</a>" ).insertAfter( '.product-description p:nth-child(1)' );
$( ".product-description" ).css( "height", "auto" );
//eliminamos párrafos vacíos
$('.product-description p').filter(function () {
     return this.innerHTML == "&nbsp;"; 
}).remove();

//variables
var elementsL = $('.product-description').children().length;
var children = $('.product-description').children();
var hasDiv = $('.product-description div').children().length;
var sel = $(children[1]).nextAll();
var contentHeight = $('.product-description').height();

//actuador
//el condicional hasDiv == 0 bloquea el script en caso de encontrar un div en el contenido
//de esta forma evitamos que se ejecute el código cuando estamos editando un concepto
if ( elementsL > 1 && contentHeight >= 120 && hasDiv == 0) {
  $('.product-description').each(function(){
    $(sel).hide();
    $(".readMore").click(function () {
      $(sel).slideToggle("fast");
      if ($(".readMore").text() == "[Read More...]") {
        $(this).text("[Read Less...]");
      } else {
        $(this).text("[Read More...]");
      }
    });
  });
} else {
  $(".readMore").hide();
}